import { ValueRightAxis } from '../../../core/components/axes/components/ValueRightAxis.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { useTimeseriesFilteredYAxis } from '../../hooks/useTimeseriesFilteredYAxis.js';
import { useTimeseriesTickAxis } from '../../hooks/useTimeseriesTickAxis.js';
import { useYScales } from '../../hooks/useYScales.js';
import { AREAS } from '../../types/timeseries-grid-area-rules.js';

export const TimeseriesValueRightAxisArea = () => {
  const { right: rightConfig } = useTimeseriesFilteredYAxis();
  const { right: scaleRight } = useYScales();
  const tickAxis = useTimeseriesTickAxis();
  const rightTickAxis = tickAxis?.right || { ticks: [], formattedTicks: [] };

  if (!rightTickAxis.ticks.length || !scaleRight) {
    return null;
  }

  return (
    <ChartGrid.GridArea gridArea={AREAS.rightAxis}>
      {({ availableWidth, availableHeight }) => {
        return (
          <ValueRightAxis
            ticks={rightTickAxis.ticks}
            formattedTicks={rightTickAxis.formattedTicks}
            containerHeight={availableHeight}
            containerWidth={availableWidth}
            scale={scaleRight.scale}
            label={rightConfig?.label}
          />
        );
      }}
    </ChartGrid.GridArea>
  );
};

TimeseriesValueRightAxisArea['displayName'] = 'TimeseriesValueRightAxisArea';
